import type { Section, SectionBuilder, SectionCardProps, SectionProps } from '../Section';
import React from 'react';
import { SectionTextView } from '../SectionTextView';
import type { RefundPolicy } from './types';
import { SectionCardView } from '../SectionCardView';
import { useTranslation } from '../../context/TranslationContext/TranslationContext';

export type RefundPolicySectionProps = SectionProps<RefundPolicy>;
export type RefundPolicyCardsProps = SectionCardProps<RefundPolicy>;

export const RefundPolicyCard: React.FC<RefundPolicyCardsProps> = ({ data, onReadMoreClick, size }) => {
  const { refundPolicy: title = 'Refund Policy' } = useTranslation();
  const shouldShowReadMore = data.length > 100;
  return (
    <SectionCardView
      title={title}
      body={data}
      onReadMoreClick={onReadMoreClick}
      showReadMore={shouldShowReadMore}
      size={size}
    />
  );
};

export const RefundPolicyView: React.FC<RefundPolicySectionProps> = ({ data }) => {
  const { refundPolicy: title = 'Refund Policy' } = useTranslation();
  return <SectionTextView title={title} text={data} />;
};

const RefundPolicySection: SectionBuilder<RefundPolicy> = (data) => ({
  key: 'refund-policy',
  CardView: ({ onReadMoreClick, size }) => (
    <RefundPolicyCard data={data} onReadMoreClick={onReadMoreClick} size={size} />
  ),
  GeneralView: () => <RefundPolicyView data={data} />,
  SingleView: () => <RefundPolicyView data={data} />,
});

export default RefundPolicySection;
